export default "__VITE_ASSET__Ccl8gByq__"